"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBase = exports.DEFAULT_MODAL_Z_INDEX = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _reactRemoveScroll = require("react-remove-scroll");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _useCursor2 = require("use-cursor");

var _Flex = require("../Flex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO: Update TypeScript definitions for this library
// https://github.com/theKashey/react-remove-scroll
var ScrollIsolation = (0, _styledComponents.default)(_reactRemoveScroll.RemoveScroll).withConfig({
  displayName: "ModalBase__ScrollIsolation",
  componentId: "g18dlb-0"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "ModalBase__Container",
  componentId: "g18dlb-1"
})(["position:fixed;top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;", ""], _styledSystem.zIndex);
var Dialog = (0, _styledComponents.default)(_Flex.Flex).attrs({
  role: "dialog"
}).withConfig({
  displayName: "ModalBase__Dialog",
  componentId: "g18dlb-2"
})(["overflow-y:auto;-webkit-overflow-scrolling:touch;> *{max-height:100%;}"]);
/**
 * BaseModal
 */

/**
 * It seems we've landed on this value as the 'top'
 */
var DEFAULT_MODAL_Z_INDEX = 9999;
exports.DEFAULT_MODAL_Z_INDEX = DEFAULT_MODAL_Z_INDEX;
var FOCUSABLE_SELECTOR = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", '[tabindex="0"]'].join(", ");
/**
 * BaseModal
 * Low-level modal that has no opinions about layout/overlay
 * Modals content using a portal, locks scroll.
 */

var ModalBase = function ModalBase(_ref) {
  var children = _ref.children,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? DEFAULT_MODAL_Z_INDEX : _ref$zIndex,
      _ref$dialogProps = _ref.dialogProps,
      dialogProps = _ref$dialogProps === void 0 ? {} : _ref$dialogProps,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      rest = _objectWithoutProperties(_ref, ["children", "zIndex", "dialogProps", "onClose"]);

  var appendEl = (0, _react.useRef)(document.createElement("div"));
  var containerEl = (0, _react.useRef)(null);
  var scrollIsolationEl = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      focusableEls = _useState2[0],
      setFocusableEls = _useState2[1];

  var _useCursor = (0, _useCursor2.useCursor)({
    max: focusableEls.length
  }),
      focusableIndex = _useCursor.index,
      handlePrev = _useCursor.handlePrev,
      handleNext = _useCursor.handleNext;

  (0, _react.useEffect)(function () {
    if (!focusableEls.length) return;
    focusableEls[focusableIndex].focus();
  }, [focusableEls, focusableIndex]);

  var handleClick = function handleClick(event) {
    if (event.target === scrollIsolationEl.current) {
      onClose();
    }
  };

  var handleKeydown = function handleKeydown(event) {
    switch (event.key) {
      case "Escape":
        // Prevent <esc> from interfering with the returned focus
        event.preventDefault();
        event.stopPropagation(); // Handle close

        return onClose();

      case "Tab":
        // Lock focus within modal
        event.preventDefault();
        event.stopPropagation(); // Move focus up or down

        event.shiftKey ? handlePrev() : handleNext();
        break;

      default:
        break;
    }
  };

  (0, _react.useEffect)(function () {
    var current = appendEl.current;
    var focusedElBeforeOpen = document.activeElement; // Append the dialog

    document.body.appendChild(current); // Gets the focusable elements

    var _focusableEls = Array.from(containerEl.current.querySelectorAll(FOCUSABLE_SELECTOR));

    setFocusableEls(_focusableEls); // Switches focus to the first focusable element

    _focusableEls.length && _focusableEls[0].focus();
    document.addEventListener("keydown", handleKeydown);
    return function () {
      // Remove the dialog
      document.body.removeChild(current); // Return the focus

      focusedElBeforeOpen.focus();
      document.removeEventListener("keydown", handleKeydown);
    };
  }, []);
  return (0, _reactDom.createPortal)(_react.default.createElement(Container, _extends({
    ref: containerEl,
    zIndex: zIndex
  }, rest), _react.default.createElement(ScrollIsolation, {
    ref: scrollIsolationEl,
    onClick: handleClick
  }, _react.default.createElement(Dialog, _extends({
    maxHeight: // Sets to `innerHeight` so as to simulate `100vh` on iOS
    window.innerHeight
  }, dialogProps), children))), appendEl.current);
};

exports.ModalBase = ModalBase;
ModalBase.displayName = "ModalBase";
//# sourceMappingURL=ModalBase.js.map